// FILE: src/api/axios.js
import axios from 'axios';
import router from '../router'; // استيراد الراوتر للتحكم في التوجيه
axios.defaults.withCredentials = true; 
const api = axios.create({
    // baseURL: 'http://127.0.0.1:8000/api', // تأكد أن هذا هو عنوان API الخلفي
    // baseURL: 'http://192.168.1.130:8888/api', // تأكد أن هذا هو عنوان API الخلفي
    baseURL: 'https://apicontrol.sinai-edu.com/api', // تأكد أن هذا هو عنوان API الخلفي
//    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// اعتراض الطلبات لإضافة التوكن تلقائياً
api.interceptors.request.use(config => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});
api.interceptors.response.use(
    // إذا كانت الاستجابة ناجحة، مررها كما هي
    response => response,
    // إذا حدث خطأ، قم بالتحقق منه
    error => {
        // التحقق إذا كان الخطأ هو 503 (Service Unavailable)
        if (error.response && error.response.status === 503) {
            // توجيه المستخدم إلى صفحة الصيانة
            // نتحقق أولاً أننا لسنا بالفعل في صفحة الصيانة لتجنب التكرار
            if (router.currentRoute.name !== 'Maintenance') {
                router.push({ name: 'Maintenance' });
            }
        }
        
        // إرجاع الخطأ ليتم التعامل معه في مكان آخر إذا لزم الأمر
        return Promise.reject(error);
    }
);
export default api;